/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import {
  Modal, Form, Input, Row, Col, notification, Button
} from 'antd';
import { read, utils } from 'xlsx';
import { uploadFile } from 'react-s3';
import * as utility from '../utils/utility';
import {
 offshoreshoreAssetWebElements, offshoreInventoryWebElements,
  onshoreEmeaInventoryWebElements, onshoreEmeaAssetWebElements, projectType as projectTypeConstant 
} from '../utils/constants';

const { offshore, onshoreEmea } = projectTypeConstant;
const AddInventoryModal = (props) => {
  const {
    isModalVisible, setIsModalVisible, inventoryModalLoading, 
    addInventoryForm, isEdit, setIsEdit, awsConfigDt, projectNo, onSave, onUpdate, 
    setInventoryModalLoading, projectType
  } = props;

  const [inventoriesFileData, setInventoryFileData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [filename, setFilename] = useState('');
  const [fileUploaded, setFileUploaded] = useState(false);

  const assetKeyword = [];
  const inventoryKeyword = [];

  if (projectType === onshoreEmea || projectType === offshore) {
    assetKeyword.push('AW REFURB COST');
    assetKeyword.push('AW NON RENTAL OBJECTS - HOLLAND');
    inventoryKeyword.push('AW CONSIGNMENT HWC');
    //  TODO replace these values  based on on shore and off shore 
    // add condition for both 
    if (projectType === onshoreEmea) {
      assetKeyword.push(...onshoreEmeaAssetWebElements);
      inventoryKeyword.push(...onshoreEmeaInventoryWebElements);  
    } else {
      assetKeyword.push(...offshoreshoreAssetWebElements);
      inventoryKeyword.push(...offshoreInventoryWebElements);
    }
  }
  assetKeyword.push('Rental');
  inventoryKeyword.push('Consigned');

  const handleCancel = () => {
    setIsModalVisible(false);
    addInventoryForm.resetFields();
    setIsEdit(false);
  };

  const S3_BUCKET = 'parts-data';
  const REGION = 'us-west-2';
  const ACCESS_KEY = awsConfigDt[0].access_key_id;
  const SECRET_ACCESS_KEY = awsConfigDt[0].secret_access_key;

const config = {
    bucketName: S3_BUCKET,
    region: REGION,
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY,
};

  const handleFileInput = (event) => {
    const { files } = event.target;
if (files.length) {
    const file = files[0];
    const fileTypeArr = file.name.split('.');
    const extention = fileTypeArr.pop();
    const typeArr = ['xls', 'xlsx'];
    if (!typeArr.includes(extention.toLowerCase())) {
      notification.warning({
        message: 'Invalid file format. Please select a file with valid format (.xls , .xlsx)',
        duration: 1.5
      });
    } else {
     setFilename(file.name);
     const reader = new FileReader();
     reader.onload = (event) => {
         const wb = read(event.target.result);
         const sheets = wb.SheetNames;
         if (sheets.length) {
             const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
             setInventoryFileData(rows);
         }
     };
     reader.readAsArrayBuffer(file);
    }
}
    setSelectedFile(event.target.files[0]);
  };

  const checkKeywordExist = (projectKeyword, matchKeyword) => {
    const keywordExist = projectKeyword.some((element1) =>
      matchKeyword.some((element2) => {
        if (element1 == null || element2 == null || typeof element1 !== 'string' || typeof element2 !== 'string') {
          return false;
        }
        const cleanElement1 = element1.replace(/[^\w\s]/g, '').toLowerCase();
        const cleanElement2 = element2.replace(/[^\w\s]/g, '').toLowerCase();
        return cleanElement1.includes(cleanElement2) || cleanElement2.includes(cleanElement1);
      }));
    return keywordExist;
  };

  const handleUpload = (file) => {
    if (inventoriesFileData && inventoriesFileData.length > 0) {
      const firstRow = inventoriesFileData[0];
      const hasProjectDefinition = firstRow && Object.prototype.hasOwnProperty.call(firstRow, 'Project Definition');
      const hasRequiredColumns = hasProjectDefinition
        && (Object.prototype.hasOwnProperty.call(firstRow, 'WBS Element') || Object.prototype.hasOwnProperty.call(firstRow, 'WBS Name'));

      if (!hasRequiredColumns) {
        notification.warning({
          message: 'Invalid file. Required columns (Project Definition, WBS Element, WBS Name) are missing.',
          duration: 3
        });
        return;
      }

      const pjctnum = [];
      const pjctType = [];
      inventoriesFileData.forEach((dt) => {
        const projectDef = dt['Project Definition'];
        if (projectDef != null && projectDef !== '' && !pjctnum.includes(projectDef)) {
          pjctnum.push(String(projectDef));
        }
        if (projectType === onshoreEmea || projectType === offshore) {
          const wbsElement = dt['WBS Element'];
          if (wbsElement != null && wbsElement !== '' && !pjctType.includes(wbsElement)) {
            pjctType.push(wbsElement);
          }
        }
        const wbsName = dt['WBS Name'];
        if (wbsName != null && wbsName !== '' && !pjctType.includes(wbsName)) {
          pjctType.push(wbsName);
        }
      });

      const validPjctType = pjctType.filter((item) => item != null && typeof item === 'string');
      const containsAssetKeyword = checkKeywordExist(validPjctType, assetKeyword);
      const containsInventoryKeyword = checkKeywordExist(validPjctType, inventoryKeyword);

      if (!pjctnum.includes(projectNo)) {
          notification.warning({
            message: `Data for the project number ${projectNo} does not exist in uploaded file`,
            duration: 1.5
          });
        } else if (!containsAssetKeyword && !containsInventoryKeyword) {
          if (projectType === onshoreEmea || projectType === offshore) {
            notification.warning({
              message: `Data for the WB Name or WB Element of project number ${projectNo} does not matching with ${projectType} project type`,
              duration: 1.5
            });
          } else {
            notification.warning({
              message: `Data for the WB Name of project number ${projectNo} does not matching with ${projectType} project type`,
              duration: 1.5
            });
          }
        } else {
          setInventoryModalLoading(true);
          uploadFile(file, config)
            .then((data) => { console.log('data', data); setFileUploaded(true); })
            .catch(async (err) => {
              setInventoryModalLoading(false);
              const body = err && typeof err.text === 'function' ? await err.text() : '';
              console.error('S3 upload failed', err && err.status, body);
              notification.error({
                message: `Upload failed (${err && err.status ? err.status : 'error'}). ${body}`,
                duration: 4
              });
            });
        }
    }
  };

  useEffect(() => {
    if (inventoriesFileData && inventoriesFileData.length > 0) {
      const firstRow = inventoriesFileData[0];
      const hasProjectDefinition = firstRow && Object.prototype.hasOwnProperty.call(firstRow, 'Project Definition');
      const hasRequiredColumns = hasProjectDefinition
        && (Object.prototype.hasOwnProperty.call(firstRow, 'WBS Element') || Object.prototype.hasOwnProperty.call(firstRow, 'WBS Name'));

      if (!hasRequiredColumns) {
        notification.warning({
          message: 'Invalid file. Required columns (Project Definition, WBS Element, WBS Name) are missing.',
          duration: 3
        });
        setInventoryFileData([]);
        return;
      }

      const pjctnum = [];
      const pjctType = [];
      inventoriesFileData.forEach((dt) => {
        const projectDef = dt['Project Definition'];
        if (projectDef != null && projectDef !== '' && !pjctnum.includes(projectDef)) {
          pjctnum.push(String(projectDef));
        }
        if (projectType === onshoreEmea || projectType === offshore) {
          const wbsElement = dt['WBS Element'];
          if (wbsElement != null && wbsElement !== '' && !pjctType.includes(wbsElement)) {
            pjctType.push(wbsElement);
          }
        }
        const wbsName = dt['WBS Name'];
        if (wbsName != null && wbsName !== '' && !pjctType.includes(wbsName)) {
          pjctType.push(wbsName);
        }
      });

      const validPjctType = pjctType.filter((item) => item != null && typeof item === 'string');
      const containsAssetKeyword = checkKeywordExist(validPjctType, assetKeyword);
      const containsInventoryKeyword = checkKeywordExist(validPjctType, inventoryKeyword);

      if (!pjctnum.includes(projectNo)) {
        notification.warning({
          message: `Data for the project number ${projectNo} does not exist in uploaded file`,
          duration: 1.5
        });
      }

      if (!containsAssetKeyword && !containsInventoryKeyword) {
        if (projectType === onshoreEmea || projectType === offshore) {
          notification.warning({
            message: `Data for the WB Name or WB Element of project number ${projectNo} does not matching with ${projectType} project type`,
            duration: 1.5
          });
        } else {
          notification.warning({
            message: `Data for the WB Name of project number ${projectNo} does not matching with ${projectType} project type`,
            duration: 1.5
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoriesFileData]);

  useEffect(() => {
    if (fileUploaded) {
          onSave(filename);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileUploaded]);

  const handleUpdate = () => {
    addInventoryForm
      .validateFields()
      .then((data) => {
          onUpdate(data.description, data.serial_number,
             data.project_asset_id, data.order_quantity);
      });
  };

  return (
    <>
      <Modal
        className="quality-modal"
        title={isEdit ? 'Update Part' : 'Add Parts'}
        centered
        visible={isModalVisible}
        onOk={() => handleUpload(selectedFile)}
        footer={isEdit ? [
          <Button 
            key="submit"
            onClick={() => handleCancel(false)} 
            disabled={inventoryModalLoading}
          >
            Cancel
          </Button>,
          <Button
            key="submit" 
            type="primary" 
            onClick={() => handleUpdate()} 
            disabled={inventoryModalLoading} 
            loading={inventoryModalLoading}
          >
            Update
          </Button>
        ] : [
          <Button 
            key="submit" 
            onClick={() => handleCancel(false)} 
            disabled={inventoryModalLoading}
          >
            Cancel
          </Button>,
          <Button
            key="submit" 
            type="primary" 
            onClick={() => handleUpload(selectedFile)} 
            disabled={inventoryModalLoading || inventoriesFileData.length === 0} 
            loading={inventoryModalLoading}
          >
            Add
          </Button>
        ]}
      >
        <div>
          {
            !isEdit ? (
              <Input
                className="border-none"
                type="file" 
                name="file" 
                id="inputGroupFile" 
                required 
                onChange={handleFileInput}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            ) : (
              <Form
                id="create-project-form"
                name="basic"
                layout="vertical"
                autoComplete="off"
                form={addInventoryForm}
                onFinish=""
              >
                <Row gutter={16}>
                  <Col lg={12}>
                    <Form.Item
                      label="Part Number"
                      name="serial_number"
                      rules={[
                    {
                      required: true,
                      message: 'Please enter the Part Number.',
                    },
                  ]}
                      normalize={(value) => utility.trimSpacesInValues(value)}
                    >
                      <Input size="large" placeholder="Enter Part Number" maxLength={100} />
                    </Form.Item>
                  </Col> 
                  <Col lg={12}>
                    <Form.Item
                      label="Description"
                      name="description"
                      rules={[
                    {
                      required: true,
                      message: 'Please enter the Part Description.',
                    },
                  ]}
                      normalize={(value) => utility.trimSpacesInValues(value)}
                    >
                      <Input size="large" placeholder="Enter Description" maxLength={200} />
                    </Form.Item>
                  </Col>
                  <Col lg={12}>
                    <Form.Item name="project_asset_id" style={{ display: 'none' }} />
                  </Col>
                           
                </Row>
                <Row gutter={16}>
                  <Col lg={12}>
                    <Form.Item
                      label="Order Quantity"
                      name="order_quantity"
                      normalize={(value) => utility.trimSpacesInValues(value)}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter the quantity.',
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        placeholder="Enter Order Quantity"
                        maxLength={6}
                        onKeyPress={(event) => utility.onlyNumberKey(event)}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )
          }
        </div>
        
      </Modal>
    </>
  );
};

export default AddInventoryModal;
